import { Component, OnInit } from '@angular/core';
import { AppState, AuthService } from '@auth0/auth0-angular';
import { Store } from '@ngrx/store';
import { flashNotificationsClear, flashNotificationsFormValidationErrorWithDetails } from '../../../../core/store/actions/flash-notifications.actions';
import { Auth0Service } from '../../../../core/services/auth0.service';
import { delay } from '../../../../core/functions/utility';

import { SharedModule } from "../../../shared.module";



@Component({
    selector: 'app-modal-verify-email',
    imports: [SharedModule],
    templateUrl: './modal-verify-email.component.html',
    styleUrls: ['./modal-verify-email.component.scss']
})
export class ModalVerifyEmailComponent implements OnInit {
  auth0Id: string
  verificationEmailResent: boolean = false;
  authReducer$: any;
  authEmail: string = '';
  isLoading = false;



  constructor(
    private store$: Store<AppState>,
    private auth0Service: Auth0Service,
    private authService: AuthService
  ) {
  }

  ngOnInit(): void {
    this.authReducer$ = this.store$.select('auth').subscribe(response => {
      if (response.profile !== null) {
        this.authEmail = response.profile.email;
      }
    });
  }

  signOut(): void {
    this.authService.logout();
  }

  async resendVerificationEmail(): Promise<void> {
    try {
      // Clear the flash notifications
      this.store$.dispatch(flashNotificationsClear());
      this.isLoading = true;
      await delay(250);

      await this.auth0Service.resendVerificationEmail(this.auth0Id);
      this.isLoading = false;
      this.verificationEmailResent = true;
    }
    catch (error) {
      this.store$.dispatch(flashNotificationsFormValidationErrorWithDetails({ message: "Unable to resend verification email.", details: JSON.stringify(error) }))
      this.isLoading = false;
    }
  }

  async refreshUser(): Promise<void> {
    window.location.reload();
  }

}
